<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="voucher-template-order-main-sidebar" position="left" lockedOpen="gt-md">
        <voucher-template-main-sidebar></voucher-template-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24" style="max-width: 100%;">
                    <input
                            autofocus
                            type="text"
                            style="padding:8px;margin:15px auto 5px auto;width:30%;"
                            placeholder="{{ 'Type to filter vouchers list...'|translate }}"
                            (input)="updateFilter($event)"
                    />
                    <!-- Voucher Groups Filter -->
                    <div style="line-height: 20px; margin: 5px 0 15px 0;">
                        <span *ngIf="voucherGroups.length > 0">
                            <button mat-raised-button *ngIf="selectedVoucherGroupId === null && !filterRecommended && !filterTheLatest"
                                    style="padding: 0 12px; font-size: 13px; height: 32px; min-width: auto;"
                                    color="primary"
                                    (click)="filterByVoucherGroup(null)">
                                <span>{{'All Vouchers'|translate}}</span>
                            </button>
                            <button mat-stroked-button *ngIf="!(selectedVoucherGroupId === null && !filterRecommended && !filterTheLatest)"
                                    style="padding: 0 12px; font-size: 13px; height: 32px; min-width: auto;"
                                    (click)="filterByVoucherGroup(null)">
                                <span>{{'All Vouchers'|translate}}</span>
                            </button>
                            &nbsp;
                            <ng-container *ngFor="let group of voucherGroups">
                                <button mat-raised-button *ngIf="selectedVoucherGroupId === group.id"
                                        style="padding: 0 12px; font-size: 13px; height: 32px; min-width: auto;"
                                        color="primary"
                                        (click)="filterByVoucherGroup(group.id)">
                                    <span>{{group.name}}</span>
                                </button>
                                <button mat-stroked-button *ngIf="selectedVoucherGroupId !== group.id"
                                        style="padding: 0 12px; font-size: 13px; height: 32px; min-width: auto;"
                                        [style.border-color]="group.color"
                                        [style.color]="group.color"
                                        (click)="filterByVoucherGroup(group.id)">
                                    <span>{{group.name}}</span>
                                </button>
                                &nbsp;
                            </ng-container>
                            &nbsp;|&nbsp;&nbsp;
                        </span>
                        <button mat-raised-button *ngIf="filterRecommended"
                                style="padding: 0 12px; font-size: 13px; height: 32px; min-width: auto;"
                                color="primary"
                                (click)="toggleRecommended()">
                            <span>{{'Recommended'|translate}}</span>
                        </button>
                        <button mat-stroked-button *ngIf="!filterRecommended"
                                style="padding: 0 12px; font-size: 13px; height: 32px; min-width: auto;"
                                (click)="toggleRecommended()">
                            <span>{{'Recommended'|translate}}</span>
                        </button>
                        &nbsp;
                        <button mat-raised-button *ngIf="filterTheLatest"
                                style="padding: 0 12px; font-size: 13px; height: 32px; min-width: auto;"
                                color="primary"
                                (click)="toggleTheLatest()">
                            <span>{{'The latest'|translate}}</span>
                        </button>
                        <button mat-stroked-button *ngIf="!filterTheLatest"
                                style="padding: 0 12px; font-size: 13px; height: 32px; min-width: auto;"
                                (click)="toggleTheLatest()">
                            <span>{{'The latest'|translate}}</span>
                        </button>
                    </div>
                    <ngx-datatable
                            class="material"
                            [rows]="rows"
                            [loadingIndicator]="loadingIndicator"
                            [columnMode]="'force'"
                            [headerHeight]="48"
                            [footerHeight]="56"
                            [rowHeight]="'auto'"
                            [scrollbarH]="true"
                            [reorderable]="reorderable"
                            [selectionType]="'checkbox'"
                            [limit]="25">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Name' | translate}}" prop="name"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Name for receipt' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="(row.nameForReceipt)?.length === 0" style="color: red; font-weight: bold;">
                                    {{'Name for receipt is empty'}} - {{'No possibility to sell!'|translate}}
                                </span>
                                <span *ngIf="(row.nameForReceipt)?.length > 0">{{row.nameForReceipt}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Group' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.group" [ngStyle]="{color: row.group.color}">
                                   {{row.group.name}}
                                </span>
                                <span *ngIf="(row.nameForReceipt)?.length > 0">{{row.nameForReceipt}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column maxWidth="150" name="{{'Sale price' | translate}}" prop="invoiceNumber">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.salePrice}}zł
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column maxWidth="100" name="{{'Services quantity' | translate}}" prop="invoiceNumber">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.services.length === 0" style="color: red; font-weight: bold;">
                                    {{row.services.length}} - {{'No possibility to sell!'|translate}}
                                </span>
                                <span *ngIf="row.services.length > 0">{{row.services.length}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column maxWidth="100" name="{{'Actions'|translate}}" sortable="false" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                                <a *appIsGranted="['Voucher templates', 'UPDATE']" routerLink="/settings/voucher-templates/edit/{{row.id}}">{{'Edit'|translate}}</a>
                                <a
                                        *appIsGranted="['Voucher templates', 'DELETE']"
                                        class="mr-8"
                                        aria-label="Delete"
                                        style="color: red;"
                                        (click)="showConfirmVoucherTemplateDialog(row)"
                                >
                                    {{'Delete'|translate}}
                                </a>

                                <a *appIsGranted="['Voucher templates', 'UPDATE']" routerLink="/logs/{{row.id}}/VoucherTemplate">{{'Logs'|translate}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
